var _circle, _rect, _rect2, _path, _circle2, _rect3, _rect4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInheritContent1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 213,
    viewBox: "0 0 198 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#C4DFF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.2432,
    y: 35,
    width: 87,
    height: 6,
    transform: "rotate(45 36.2432 35)",
    fill: "#A9CFF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7607,
    y: 39.2422,
    width: 87,
    height: 6,
    transform: "rotate(135 97.7607 39.2422)",
    fill: "#A9CFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1875 57.2246V75.8867H61.6855V66.5352H60.1064V75.0254H57.625V69.6831L56.1484 71.6416C54.4155 70.729 53.2979 69.1807 52.6313 67.2837C52.0161 69.4678 50.9189 71.252 49.1348 72.3184L47.5146 70.3086C50.355 68.709 51.2983 65.4072 51.3086 61.8389V61.2441H48.1504V59.1523H56.7021V61.2441H53.8516V61.8389C53.8516 65.0894 54.8154 68.186 57.625 69.6421V57.4912H60.1064V64.4023H61.6855V57.2246H64.1875ZM72.9443 60.4238C72.9341 62.813 74.2876 65.1304 77.3125 66.1045L75.9385 68.1553C73.8979 67.4683 72.4829 66.1353 71.6729 64.4331C70.8423 66.2993 69.3555 67.7656 67.2021 68.5039L65.7461 66.4326C68.9351 65.4482 70.2988 62.9463 70.3193 60.4033V58.373H72.9443V60.4238ZM68.7402 75.5586V69.5498H71.4062V73.4668H81.5576V75.5586H68.7402ZM78.2354 70.9033V57.2246H80.8604V62.6182H83.3828V64.833H80.8604V70.9033H78.2354Z",
    fill: "#374969"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 147,
    r: 66,
    fill: "#374969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103.243,
    y: 115,
    width: 87,
    height: 6,
    transform: "rotate(45 103.243 115)",
    fill: "#425C8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.761,
    y: 119.242,
    width: 87,
    height: 6,
    transform: "rotate(135 164.761 119.242)",
    fill: "#425C8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.811 149.647V151.678H133.879C134.269 153.124 136.135 154.467 139.59 154.856L138.688 156.805C135.673 156.436 133.53 155.328 132.433 153.759C131.356 155.318 129.244 156.456 126.24 156.805L125.337 154.856C128.772 154.467 130.608 153.124 131.018 151.678H126.219V149.647H138.811ZM123.922 148.007V139.209H126.506V141.608H130.423V139.209H133.028V148.007H123.922ZM126.506 145.895H130.423V143.618H126.506V145.895ZM135.981 148.889V138.245H138.606V148.889H135.981Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInheritContent1);
export default __webpack_public_path__ + "static/media/IcInheritContent1.0ca86570278ccf9cf7fdbc8d1d9443b8.svg";
export { ForwardRef as ReactComponent };